document.addEventListener("DOMContentLoaded", (event) => {
    var storageKey = "smokeAlarmCalculatorResult";

    function getStoredResultData() {
        try {
            var storedResult = sessionStorage.getItem(storageKey);

            if(!storedResult){
                return null;
            }

            return JSON.parse(storedResult);
        } catch (error) {
            return null;
        }
    }

    function getCalculatorPageUrl() {
        return $("#smoke-alarm-calculator").attr("data-calculator-url") || "/pages/smoke-alarm-calculator";
    }

    function redirectToCalculatorPage() {
        window.location.href = getCalculatorPageUrl();
    }

    function renderResult(data) {
        $("#pack-of-needed").html(data.total);
        $(".total-qunatity").html(data.total);
        $("#result-list").empty();
        $("#review-answers").empty();

        data.resultItems.forEach(function(item) {
            $("#result-list").append($("<li>").text(item));
        });

        data.reviewItems.forEach(function(item) {
            var reviewItem = $("<div>");
            reviewItem.append($("<h4>").text(item.question));
            reviewItem.append($("<p>").text("Your answer: ").append($("<span>").text(item.answer)));
            $("#review-answers").append(reviewItem);
        });

        $("#result").fadeIn(10);
    }

    $(".review-answers-button").click(function(){
        $("#review-answers-wrapper").fadeToggle(200);
    });

    $("#install-hard-wired-button").click(function(){
        $("#install-hard-wired-content").fadeToggle(200);
    });

    $("#reset-button").click(function(event){
        event.preventDefault();

        try {
            sessionStorage.removeItem(storageKey);
        } catch (error) {}

        redirectToCalculatorPage();
    });

    var resultData = getStoredResultData();

    if(!resultData){
        redirectToCalculatorPage();
        return;
    }

    renderResult(resultData);
});
